import { safe } from '../utils/contrast.js';
import { t } from '../utils/i18n.js';

// ── VENTA DE ENTRADAS ────────────────────────────────
// El widget (día → sesión → entradas → datos → pago) NO se pinta aquí: lo construye ENTERO
// `core/entradas-runtime.js` sobre el contenedor `[data-n3i-entradas="ID"]`, en el editor y en el
// publicado, igual que en el tag de una página a mano. El bloque solo pone el titular, el subtítulo
// y a qué evento apunta (`props.source.event_id`); precios, sesiones y aforo se leen EN VIVO del ERP
// (`/site_entradas/*`), así que cambiar un precio no obliga a republicar.
//
// manualOnly (block-meta.js): vende plazas REALES de un evento del ERP; la IA no puede colocarlo.
// Sin evento elegido, el aviso es `.editor-only` (lo borra la publicación) y el contenedor no sale:
// un widget sin evento no tiene nada que enseñar.

export function eventoDe(p) {
    const id = String((p.source && p.source.event_id) || '').trim();
    return /^\d{1,10}$/.test(id) ? id : '';
}

export const entradasBlock = (rawProps, index = 0) => {
    const p = safe(rawProps);
    const variant = p.variant || 'v1';
    const title = p.title || t('ne_titulo_bloque');
    const subtitle = p.subtitle || '';
    const evento = eventoDe(rawProps || {});
    const cuerpo = evento
        ? `<div class="ne-bloque-widget" data-n3i-entradas="${evento}"></div>`
        : `<div class="ne-sin-evento editor-only">Elige el evento que se vende aquí: botón «Evento» de la barra de esta sección.</div>`;
    return `
    <section id="bloque-entradas-${index}" class="reveal variant-${variant} entradas-section"
             style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --accent-contrast:${p.accentContrast || '#fff'}; --font:'${p.fontFamily || 'Inter'}';">
        <div class="entradas-cabecera">
            <h2 data-field="title" contenteditable="true">${title}</h2>
            <p data-field="subtitle" contenteditable="true">${subtitle}</p>
        </div>
        ${cuerpo}
    </section>`;
};
